<template>
  <base-modal :box="box_init" :step="step">
    <z-form ref="form" @submit.native.prevent="save">
      <form-input-name v-model="form.name" :box_type="box.type" />

      <z-form-group class="row">
        <div class="col-4 text-right">
          {{ $t('pbx.worksheet.action.postback.url') }}
        </div>
        <z-form-input class="col-8" :rules="{ url: true, required: true }" :box_type="'url'">
          <i-input v-model="form.params.url" :placeholder="$t(`pbx.worksheet.action.type.url`)" />
        </z-form-input>
      </z-form-group>

      <z-form-group class="row">
        <div class="col-4 text-right textarea-label">Data</div>
        <z-form-input class="col-8" :rules="{ required: true }">
          <i-input
            v-model="form.params.data"
            type="textarea"
            :rows="5"
            :placeholder="$t(`pbx.worksheet.action.postback.area`)"
          />
        </z-form-input>
      </z-form-group>
    </z-form>

    <i-button
      slot="footer-ok"
      slot-scope="{ is_button_loading }"
      type="success"
      size="large"
      :loading="is_button_loading"
      @click="save"
    >
      {{ $t('pbx.worksheet.modal.action.main.button.ok') }}
    </i-button>
  </base-modal>
</template>

<script>
  import BaseModal from '../../../_base/index';
  import FormInputName from '../../../_base/_fragments/form-input-name';
  import { StepMixin } from '../../../_base/step-mixin';

  /**
   * props.box - автоматически прокидывается в form
   * чтобы сохранить состояние шага, используй mixin_save_step из StepMixin
   */

  export default {
    components: {
      BaseModal,
      FormInputName
    },

    mixins: [StepMixin],

    methods: {
      save: function() {
        this.$refs.form.validate().then(is_valid => {
          if (is_valid) {
            const box = this.mixin_get_box(this.form);
            this.$emit('on-save', box);
          }
        });
      }
    }
  };
</script>

<style>
  .textarea-label {
    align-self: flex-start;
    margin-top: 4px;
  }
</style>
